import { useEffect, useState } from 'react';

const styles = {
    root: {
        height: 18,
        width: 18,
        cursor: 'pointer',
        border: 0,
        background: 'none',
        padding: 0
    },
    dot: {
        backgroundColor: '#F1F3F7',
        height: 8,
        width: 8,
        borderRadius: 6,
        margin: 5
    },
    activeDot: {
        backgroundColor: '#1BABE2',
        height: 8,
        width: 8,
        borderRadius: 6,
        margin: 5
    }
};

export const Dot = ({ active, handleClick, index }) => {
    const { dot, activeDot, root } = styles;
    const [styleDot, setStyleDot] = useState(dot);

    useEffect(() => {
        if (active === index) {
            return setStyleDot(activeDot);
        }
        return setStyleDot(dot);
    }, [active, activeDot, dot, index]);

    return (
        <button type="button" style={root} value={index} onClick={() => handleClick(index)}>
            <div style={styleDot} />
        </button>
    );
};
